// extracted by mini-css-extract-plugin
export default {"blankSpace":"footer_blankSpace__ATDZX"};